import { render } from "./editAddress.vue?vue&type=template&id=6f3207e6&scoped=true"
import script from "./editAddress.vue?vue&type=script&lang=js"
export * from "./editAddress.vue?vue&type=script&lang=js"

import "./editAddress.vue?vue&type=style&index=0&id=6f3207e6&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3207e6"]])

export default __exports__